"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectReplyOption')(function selectReplyOption(replyAllByDefault, state) {
    var optionState = state.optionState;
    optionState.replyAllByDefault = replyAllByDefault;
}));
//# sourceMappingURL=selectReplyOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reply-option/lib/actions/selectReplyOption.js
// module id = 5050
// module chunks = 2